const basePath = '/Api';

/**
 * URIs pour toutes les pages de connexion
 */
export const ACCOUNT_URI = `${basePath}/Account`;
export const ACCOUNT_SIGNIN_URI = `${basePath}/Account/SignIn`;
export const ACCOUNT_SIGNOUT_URI = `${basePath}/Account/SignOut`;
export const ACCOUNT_CHANGE_PASSWORD_URI = `${basePath}/Account/ChangePassword`;
export const ACCOUNT_RESET_PASSWORD_URI = `${basePath}/Account/ResetPassword`;
export const ACCOUNT_SET_PASSWORD_URI = `${basePath}/Account/ChoosePassword`;
export const ACCOUNT_URL_TOKEN_VALIDATOR_URI = `${basePath}/Account/CheckTokenExpiration`;

/**
 * URIs pour la récupération des données de l'utilisateur et de ses déplacements
 */
export const CUSTOMER_URI = `${basePath}/Customer`;
export const CUSTOMER_TRIPS_URI = `${basePath}/Trips`;
export const CUSTOMER_TRIPS_TEMPLATE_URI = `${basePath}/Trips/Templates`;
export const CUSTOMER_TRIPS_CANCELLATION_URI = `${basePath}/Trips/Cancel`;
export const CUSTOMER_TRIPS_NEXT_TRIP_SERVICE_INFO_URI = `${basePath}/Trips/NextService`;
export const CUSTOMER_TRIP_INTERRUPTION_CALENDAR_URI = `${basePath}/Trips/Templates/InterruptionCalendar`;
export const CUSTOMER_TRIP_TEMPLATE_INTERRUPTION = `${basePath}/Trips/Templates/Interruptions`;
export const CUSTOMER_TRIPS_HISTORY_URI = `${CUSTOMER_TRIPS_URI}/History`;
export const CUSTOMER_TRIPS_HISTORY_SEND_EMAIL_URI = `${basePath}/Trips/History/SendEmail`;
export const postTripSendEmailUri = (requestKey: string) => `${basePath}/Trips/${requestKey}/SendEmail`;
export const postTripTemplateSendEmailUri = (requestKey: string) => `${basePath}/Trips/Templates/${requestKey}/SendEmail`;

/**
 * URIs relatifs au formulaire de réservation
 */
export const CUSTOMER_BOOKING_CALENDAR_URI = `${basePath}/Customer/BookingCalendar`;
export const CUSTOMER_BOOKING_CALENDAR_TEMPLATE_URI = `${basePath}/Customer/BookingCalendar/Template`;
export const CUSTOMER_FAVOURITE_ADDRESSES_URI = `${basePath}/Customer/BookingAddresses/Favourites`;
export const CUSTOMER_RECENT_ADDRESSES_URI = `${basePath}/Customer/BookingAddresses/History`;
export const CUSTOMER_SERVICE_ADDRESSES_URI = `${basePath}/Customer/BookingAddresses/Service`;
export const BOOKING_CUSTOMER_COMPANIONSHIP_URI = `${basePath}/Customer/Companionship`;
export const BOOKING_HOURS_URI = `${basePath}/Customer/BookingHours`;
export const CUSTOMER_BOOKING_HOURS_TEMPLATE_URI = `${basePath}/Customer/BookingHours/Template`;
export const BOOKING_PUBLIC_ADDRESSES_SEARCH = `${basePath}/Réseau/Recherche`;
export const BOOKING_SUBMISSION_URI = `${basePath}/Customer/Booking`;
export const BOOKING_SUBMISSION_TEMPLATE_URI = `${basePath}/Customer/Booking/Templates`;
export const CUSTOMER_TRIP_MODIFICATION_URI = `${basePath}/Bookings`;
export const CUSTOMER_TRIP_DUPLICATION_URI = (requestKey: string) => `${basePath}/Bookings/${requestKey}/Duplicate`;

/**
 * Autres URIs.
 */
export const MAP_TRIP_SERVICE_URI = `${basePath}/Trips/Service/Carte`;
export const SYSTEM_SETTINGS_URI = `${basePath}/Système`;
export const CONTEXTUAL_HELP_URI = `${basePath}/Système/AidesContextuelles`;
export const CUSTOMER_ASSISTIVE_DEVICES = `${basePath}/Customer/AssistiveDevices`;
export const SYSTEM_APP_ERROR_LOG_URI = `${basePath}/Système/ErreurApplicative`;
export const CLIENT_MESSAGES_URI = `${basePath}/Système/MessagesClient`;
export const HOT_SURVEY_URI = `${basePath}/Feedbacks/mesure-a-chaud`;
export const HOT_SURVEY_NOTIFY_VISITED_URI = `${basePath}/Feedbacks/mesure-a-chaud/NotifyVisited`;
